import React from "react";

function AddSceneIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="99.901"
      height="96.43"
      viewBox="0 0 99.901 96.43"
    >
      <defs>
        <filter
          id="Tracciato_70"
          x="0"
          y="0"
          width="99.901"
          height="96.43"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="2" dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feFlood floodColor="#bebebf" floodOpacity="0.749" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="OBJECTS" transform="translate(-0.41 -0.17)">
        <g
          id="Raggruppa_212"
          data-name="Raggruppa 212"
          transform="translate(4.41 4.17)"
        >
          <g transform="matrix(1, 0, 0, 1, -4, -4)" filter="url(#Tracciato_70)">
            <path
              id="Tracciato_70-2"
              data-name="Tracciato 70"
              d="M50.1,88.6H46.625A42.218,42.218,0,0,1,4.41,46.385h0A42.218,42.218,0,0,1,46.625,4.17H50.1A42.218,42.218,0,0,1,92.311,46.385h0A42.218,42.218,0,0,1,50.1,88.6Z"
              transform="translate(-0.41 -0.17)"
              fill="#fff"
            />
          </g>
          <g
            id="Raggruppa_211"
            data-name="Raggruppa 211"
            transform="translate(26.924 25.188)"
          >
            <rect
              id="Rettangolo_111"
              data-name="Rettangolo 111"
              width="5.488"
              height="34.1"
              transform="translate(14.306)"
              fill="#2d2e82"
            />
            <rect
              id="Rettangolo_112"
              data-name="Rettangolo 112"
              width="34.1"
              height="5.488"
              transform="translate(0 14.306)"
              fill="#2d2e82"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AddSceneIcon;
